import type { FaireProductEntity } from "../../entity_types/product";

export const p_4e5rg3z7dp: FaireProductEntity = {
  token: "p_4e5rg3z7dp",
  type: "product",
  name: "18k Gold Filled 2.5mm Flat Figaro Chain",
  brandToken: "b_q2rp7x96kv",
  brandName: "GoldFi",
  imageUrl:
    "https://cdn.faire.com/fastly/4a885d69157b7a21f2c6b2d38c04b36d81c1b391719536566752de71db1de168.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7d23618723477667eaa5ffe7864654b11edd32238c6a675d25689b55f3cdfa32.jpeg",
    "https://cdn.faire.com/fastly/93a6448b94c6eccafd7bf283b035e050aee3a9fdcab3dd8368621b1850c1b434.jpeg",
    "https://cdn.faire.com/fastly/0e24e9c6fd67a20d2adb1b9a02e50b8bc2681a04ac71cb536f7577e99cdeffe2.jpeg",
  ],
  priceDollars: 14.76,
  description:
    "The 18k Gold Filled Figaro Chain is a must-have for those who appreciate classic style. Its timeless elegance exudes sophistication and makes a bold statement when paired with any outfit.\n\n * Metal: 18k Gold Filled \n * Available sizes: 16, 18, 20, 22, and 24 inches \n * Hypoallergenic jewelry - Nickel Free \n * Water-resistant \n * Rigorously manufactured under CA Prop 65 and EU standards \n * Made in Brazil \nWe carry the matching anklet here \n",
  tags: [],
  msrpDollars: 36.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:23.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
